import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { observer } from 'mobx-react-lite';

import routes from 'modules/routing-module/routes';
import { Confirmation } from 'components/common';
import { playlistsStore } from 'stores/playlists';

const PlaylistDelete: React.FC = () => {
  const intl = useIntl();

  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const playlist = playlistsStore.list.find((p) => p.id === id);

  const message = intl.formatMessage(
    {
      id: 'Deleting Confirm',
    },
    { it: playlist ? playlist.name : id },
  );

  const handleConfirm = React.useCallback(() => {
    if (id) {
      playlistsStore.deletePlaylist(id);

      navigate(routes.PlaylistsList.path, { replace: true });
    }
  }, [id]);

  const handleCancel = React.useCallback(() => {
    navigate(routes.PlaylistsList.path, { replace: true });
  }, []);

  return (
    <Confirmation
      message={message}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );
};

export default observer(PlaylistDelete);
